import {checkPseudoStyles} from "../../../../formElement/RadioCard/styles";
import {GREY_INFO_COLOR, INFO_BACKGROUND} from "../../../../../../../../../themes/themeConfigurator";

const replaceWithCheckStyles = {
  // replace radio svg with fontawesome check icon
  '& svg': {
    display: 'none',
  },
  '& .MuiIconButton-label::before': checkPseudoStyles
};

export default (theme) => ({
  checkboxQuestionContainer: {
    marginLeft: 0,
    marginRight: 0,
    borderRadius: 16,
    padding: theme.spacing(3),
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.10), 0px 1px 3px 1px rgba(0, 0, 0, 0.10)',
    width: '100%',
    height: '100%',
    alignContent: 'center',
    border: '1px solid',
    borderColor: 'transparent',
    cursor: 'pointer',
    '& .MuiFormControl-root': {
      pointerEvents: 'none', // disable click events on checkbox/label
      '& .Mui-checked': {
        ...replaceWithCheckStyles
      }
    },
    '&:hover': {
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.10)',
      // replace radio svg with fontawesome check icon
      '& .MuiIconButton-root': replaceWithCheckStyles,
    },
    '&.checked': {
      borderColor: theme.palette.primary.main,
    },
    '&.disabled': {
      cursor: 'inherit',
      pointerEvents: 'none',
      opacity: 0.5,
    }
  },
  helpText: {
    marginLeft: 32,
    marginTop: '1em',
    fontSize: '0.9em',
  },
  infoIcon: {
    color: GREY_INFO_COLOR,
    cursor: 'pointer',
    fontSize: 16,
  },
  dialogTitleInfo: {
    background: INFO_BACKGROUND,
    paddingRight: 48
  },
  dialogTitleIcon: {
    marginRight: 10,
    color: theme.palette.primary.main,
  },
  dialogContent: {
    whiteSpace: 'pre-line'
  }
})